import Created from './Created';

export default Created;
